@use "../../../../styles/Constants.scss" as Constants;
@use "../../../../styles/Colors.scss" as Colors;

.additionalFilter {
	margin: 2px 2px 0 0;

	& :global(.dropdown-toggle) {
		padding: 0 Constants.$val-spacing-xs 0 Constants.$val-spacing-s;
	}

	& :global(.dropdown-item__content) {
		display: flex;
		align-items: center;
		white-space: nowrap;
		padding-right: 0;
	}

	& :global(.dropdown-menu__selected) {
		display: flex;
		align-items: center;
	}

	& :global(.dropdown-menu__with-caret) {
		margin-left: Constants.$val-spacing-s;
	}

	& :global(.dropdown-menu__close-icon) {
		padding-right: Constants.$val-spacing-xs;
	}
}

.additionalFilterWithoutDropdown {
	// We want to get same result as we have with additionalFilter, but we're not using a dropdown here so we have to style it differently
	margin: 2px 2px 0 0;
	.icon {
		cursor: pointer;
		color: Colors.$col-greyFontLight;
		display: flex;
		align-items: center;
		padding-right: Constants.$val-spacing-s;

		&:hover,
		&:active,
		&:focus {
			color: Colors.$col-greyDark;
		}
	}

	.appliedFilterContent {
		padding: 5px 4px 5px 16px;
	}
}

.noneOption {
	color: Colors.$col-greyFontLight;
}

.dropdownOption {
	white-space: nowrap;
	min-width: 220px;

	& + div {
		margin-left: Constants.$val-spacing-s;
	}
}

.appliedFilter {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-design-blue500;
	display: flex;
}

.appliedFilterContent {
	color: Colors.$col-design-blue500;
	display: flex;
	white-space: nowrap;
}

.appliedFilterCounter {
	background: Colors.$col-design-blue500;
	color: Colors.$col-white;
	padding: 1px Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeSmall;
	border-radius: Constants.$val-borderRadius;
	margin-left: Constants.$val-spacing-s;
	line-height: 1;
	display: flex;
	align-items: center;
}

.emptyFilter {
	background-color: Colors.$col-design-grey13;
	border: 1px solid Colors.$col-greyMid;
}

.emptyFilterContent {
	color: Colors.$col-greyDark;
}

.bulkModalStyle {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-design-grey14;
	margin: 0;

	.appliedFilterContent {
		color: Colors.$col-greyDark;
	}
}

.single-select-with-secondary-container {
	position: relative;
}

.single-select-with-secondary {
	display: flex;
	flex-direction: column;
	background-color: Colors.$col-white;
	padding: Constants.$val-spacing-m;
	z-index: 1002;
	position: relative;

	&--open {
		position: absolute;
	}

	&__primary-dropdown {
		background-color: red;
	}

	& > div > :global(.show.dropdown) > :global(.dropdown-menu) {
		z-index: 0;
		position: unset;
	}

	&__secondary {
		min-height: 200px;
		min-width: 200px;
		background-color: red;
	}
}
